<template>
  <div style="display: inline-block; position: relative;">
    <!-- <transition name="flash">
      <span
        class="new-tag pulse"
        style="
          position: absolute;
          top: -8px;
          left: 95%;
          transform: translateX(-50%);
          background: #ff4081 !important;
          color: #fff;
          font-size: 10px;
          font-weight: bold;
          border-radius: 8px;
          padding: 2px 8px;
          z-index: 1100;
          box-shadow: 0 2px 8px rgba(0,0,0,0.12);
          letter-spacing: 1px;
        "
      >
        جديد
      </span>
    </transition> -->
    <v-btn 
      icon 
      @click="toggleTheme" 
      :title="isDark ? 'الوضع الليلي' : 'الوضع النهاري'"
      :loading="isLoading"
      :disabled="isLoading"
      class="theme-toggle-btn pulse"
      style="z-index: 1000; position: relative;width: 50px !important;"
    >
      <v-icon v-if="isDark" color="white">mdi-weather-night</v-icon>
      <v-icon v-else color="dark">mdi-white-balance-sunny</v-icon>
      <!--<span style="font-size: 13px; margin-right: 8px; margin-left: 4px; font-weight: 700;">
         {{ isDark ? 'ليلي' : 'نهاري' }} 
      </span>-->
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ThemeToggle',
  computed: {
    ...mapGetters(['isDark']),
    isLoading() {
      return this.$store.state.axios_loader;
    }
  },
  mounted() {
    // Initialize theme on component mount
    this.initializeTheme();
  },
  methods: {
    ...mapActions(['initializeTheme', 'toggleTheme']),
  },
};
</script>

<style scoped>


.theme-toggle-btn:hover {
  background: #3f4147 !important;
  transform: scale(1.05) !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25) !important;
}

/* Dark mode specific styling */
.dark .theme-toggle-btn {
  background: #171a1f !important;
  color: #23272e !important;
  border-color: #3a3f48 !important;
}
.dark .theme-toggle-btn i {
  color: #d2d2d2 !important;
  border-color: #666 !important;
}
.dark .theme-toggle-btn:hover {
  background: #111418 !important;
}

/* Ensure the button is always visible */
.theme-toggle-btn:focus {
  outline: 2px solid #00acf1 !important;
  outline-offset: 2px !important;
}
</style> 
<style scoped>
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 64, 129, 0.7);
    }
    70% {
      box-shadow: 0 0 0 8px rgba(255, 64, 129, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 64, 129, 0);
    }
  }
  .pulse {
    animation: pulse 1.5s infinite;
  }
  </style>